module.exports = __webpack_public_path__ + "img/about_header.56b1b163.png";